<template>
    <div class="apj-tools">
        <div class="tools-item has-transaction" @mouseover="changeToolIndex(1)" @mouseout="changeToolIndex(0)" @click="toTel">
            <i class="iconfont icondianhua1 tool-icon" style="font-size:20px;margin-left:20px;"></i>
            <span class="tool-text" v-show="toolIndex == 1">0756-6338632</span>
        </div>
        <div class="tools-item has-transaction" @mouseover="changeToolIndex(2)" @mouseout="changeToolIndex(0)" @click="toEmail">
            <i class="iconfont iconziyuan tool-icon" style="font-size:24px;margin-left:18px;"></i>
            <span class="tool-text" v-show="toolIndex == 2">BD@apjcorp.com</span>
        </div>
        <div class="tools-item has-transaction" @mouseover="changeToolIndex(3)" @mouseout="changeToolIndex(0)" @click="openBaiduMap">
            <i class="iconfont icondizhi tool-icon" style="font-size:24px;margin-left:18px;"></i>
            <span class="tool-text" v-show="toolIndex == 3">广东省珠海市唐家湾大学路101号清华科技园4栋11层</span>
        </div>
        <div class="tools-item qr-transaction" @mouseover="changeToolIndex(4)" @mouseout="changeToolIndex(0)">
            <i v-show="toolIndex != 4" class="iconfont iconerweima tool-icon" style="font-size:28px;margin-left:16px;"></i>
            <img v-show="toolIndex == 4" class="tool-qrcode" src="@/assets/images/qrcBottom.jpg" />
        </div>
        <el-backtop class="tools-item" style="border-radius: 0;">
            <i class="iconfont iconshang tool-icon" style="margin-left:20px;font-size:20px;"></i>
        </el-backtop>
    </div>
</template>

<script>
export default {
    data() {
        return {
            toolIndex: 0
        }
    },
    methods: {
        changeToolIndex(index) {
          this.toolIndex = index;
        },
        openBaiduMap() {
          window.open('https://j.map.baidu.com/39/72MJ')
        },
        toEmail() {
          location.href='mailto:BD@apjcorp.com'
        },
        toTel() {
          location.href = 'tel://0756-6338632'
        }
    }
}
</script>


<style lang="scss" scoped>
@import '@/assets/theme.scss';

/**  replace element css */
.el-backtop {
  position: initial;
}

/** apj-tools */
.apj-tools {
  position: fixed;
  z-index: 100;
  right: 20px;
  top: 30%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}

.tools-item {
  width: 60px;
  height: 60px;
  margin-top: 10px;
  box-shadow: 0px 0px 5px #eeeeee;
  background-color: $color-bg-white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: $color-text-primary;
}

.tools-item:hover {
  cursor: pointer;
  background-color: $color-bg-primary;
  color: $color-text-white;
}

.tool-qrcode {
  margin: 10px;
  width: 130px;
  height: 130px;
}

.has-transaction:hover {
  width: 250px;
  transition: 0.4s;
  // animation: showToolDetail 0.4s ;
  // -webkit-animation: showToolDetail 0.4s ;
}

.has-transaction:nth-child(3):hover {
  width: 450px;
  transition: 0.4s;
}

.qr-transaction:hover {
  width: 150px;
  height: 150px;
  animation: showQrDetail 0.4s ;
  -webkit-animation: showQrDetail 0.4s ;
}

.qr-transaction:hover .tool-qrcode {
  width: 130px;
  height: 130px;
  animation: showQrImage 0.4s ;
  -webkit-animation: showQrImage 0.4s ;
}

.tool-icon {
  margin-left: 16px;
}

.tools-item i,
.tools-item span {
  color: inherit;
}

.tool-text {
  padding-left: 16px;
  white-space: nowrap;
}

@keyframes showToolDetail
	{
	from {width:60px;}
	to {width:250px;}
}

/*Safari 和 Chrome:*/
@-webkit-keyframes showToolDetail
{
	from {width:60px;}
	to {width:250px;}
}

@keyframes showQrDetail
{
	from {
    width: 60px;
    height: 60px;
  }
	to {
    width: 150px;
    height: 150px;
  }
}

/*Safari 和 Chrome:*/
@-webkit-keyframes showQrDetail
{
	from {
    width: 60px;
    height: 60px;
  }
	to {
    width: 150px;
    height: 150px;
  }
}


@keyframes showQrImage
{
	from {
    width: 40px;
    height: 40px;
  }
	to {
    width: 130px;
    height: 130px;
  }
}

/*Safari 和 Chrome:*/
@-webkit-keyframes showQrImage
{
	from {
    width: 40px;
    height: 40px;
  }
	to {
    width: 130px;
    height: 130px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apj-tool/apj-tool.vue